/* Account Combobox Styles */
.account-combobox {
  position: relative;
  width: 100%;
}

/* Trigger Button */
.account-combobox-trigger {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 6px;
  color: #e0e0e0;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.account-combobox-trigger:hover:not(:disabled) {
  border-color: #667eea;
  background: #2d2d2d;
}

.account-combobox-trigger:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.account-combobox-trigger:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.account-combobox-trigger-text {
  flex: 1;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.account-combobox-trigger-icon {
  flex-shrink: 0;
  margin-left: 8px;
  color: #9ca3af;
  transition: transform 0.2s ease;
}

/* Dialog Element */
.account-combobox-dialog {
  padding: 0;
  border: none;
  border-radius: 12px;
  background: transparent;
  max-width: 500px;
  width: calc(100% - 32px);
  max-height: 80vh;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
  margin: auto;
}

.account-combobox-dialog::backdrop {
  background: rgba(0, 0, 0, 0.75);
  backdrop-filter: blur(4px);
}

.account-combobox-dialog[open] {
  animation: dialogFadeIn 0.2s ease-out;
}

@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

/* Modal Container */
.account-combobox-modal {
  background: #1e1e1e;
  border: 1px solid #444;
  border-radius: 12px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  max-height: 80vh;
}

/* Modal Header */
.account-combobox-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #333;
  background: #232323;
}

.account-combobox-modal-title {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: #e0e0e0;
}

.account-combobox-header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

/* Toggle Switch */
label.account-combobox-toggle {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  position: relative;
  margin: 0;
}

.account-combobox-toggle-input {
  position: absolute;
  opacity: 0;
  width: 0;
  height: 0;
}

.account-combobox-toggle-slider {
  position: relative;
  display: inline-block;
  width: 42px;
  height: 24px;
  background: #444;
  border-radius: 12px;
  transition: all 0.3s ease;
}

.account-combobox-toggle-slider::after {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 18px;
  height: 18px;
  background: #e0e0e0;
  border-radius: 50%;
  transition: all 0.3s ease;
}

.account-combobox-toggle-input:checked + .account-combobox-toggle-slider {
  background: #667eea;
}

.account-combobox-toggle-input:checked + .account-combobox-toggle-slider::after {
  transform: translateX(18px);
}

.account-combobox-toggle:hover .account-combobox-toggle-slider {
  background: #555;
}

.account-combobox-toggle-input:checked + .account-combobox-toggle-slider:hover {
  background: #7c8ef0;
}

.account-combobox-toggle-label {
  font-size: 14px;
  color: #e0e0e0;
  white-space: nowrap;
}

.account-combobox-close-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background: transparent;
  border: none;
  border-radius: 6px;
  color: #9ca3af;
  cursor: pointer;
  transition: all 0.2s ease;
}

.account-combobox-close-btn:hover {
  background: rgba(102, 126, 234, 0.2);
  color: #e0e0e0;
}

.account-combobox-close-btn:active {
  transform: scale(0.95);
}

/* Search Wrapper */
.account-combobox-search-wrapper {
  position: relative;
  padding: 16px 20px;
  border-bottom: 1px solid #333;
  background: #1e1e1e;
}

.account-combobox-search-icon {
  position: absolute;
  right: 28px;
  top: 50%;
  transform: translateY(-50%);
  color: #9ca3af;
  pointer-events: none;
  z-index: 1;
}

.account-combobox-search {
  width: 100%;
  padding: 10px 36px 10px 12px;
  background: #2a2a2a;
  border: 1px solid #444;
  border-radius: 8px;
  color: #e0e0e0;
  font-size: 14px;
  transition: all 0.2s ease;
}

.account-combobox-search:focus {
  outline: none;
  border-color: #667eea;
  background: #2d2d2d;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.2);
}

.account-combobox-search::placeholder {
  color: #6b7280;
}

/* Options List */
.account-combobox-options {
  flex: 1;
  overflow-y: auto;
  padding: 8px;
  min-height: 200px;
  max-height: calc(80vh - 160px);
}

/* Custom Scrollbar */
.account-combobox-options::-webkit-scrollbar {
  width: 10px;
}

.account-combobox-options::-webkit-scrollbar-track {
  background: #1e1e1e;
}

.account-combobox-options::-webkit-scrollbar-thumb {
  background: #444;
  border-radius: 5px;
  border: 2px solid #1e1e1e;
}

.account-combobox-options::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* Option Item */
.account-combobox-option {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  margin-bottom: 4px;
}

.account-combobox-option:last-child {
  margin-bottom: 0;
}

.account-combobox-option:hover {
  background: rgba(102, 126, 234, 0.1);
}

.account-combobox-option.highlighted {
  background: rgba(102, 126, 234, 0.15);
}

.account-combobox-option.selected {
  background: rgba(102, 126, 234, 0.2);
}

.account-combobox-option.selected {
  color: #a5b4fc;
  font-weight: 500;
}

/* Option Content */
.account-combobox-option-content {
  flex: 1;
  min-width: 0;
  margin-right: 12px;
}

.account-combobox-option-name {
  font-size: 15px;
  color: #e0e0e0;
  font-weight: 400;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
}

.account-combobox-option-id {
  font-size: 13px;
  color: #9ca3af;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 1.3;
}

/* Favorite Button */
.account-combobox-favorite-btn {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  border-radius: 8px;
  color: #6b7280;
  cursor: pointer;
  transition: all 0.2s ease;
  padding: 0;
}

.account-combobox-favorite-btn:hover {
  background: rgba(102, 126, 234, 0.2);
  color: #fbbf24;
}

.account-combobox-favorite-btn:active {
  transform: scale(0.9);
}

.account-combobox-favorite-btn.active {
  color: #fbbf24;
}

.account-combobox-favorite-btn svg {
  width: 18px;
  height: 18px;
}

/* Empty State */
.account-combobox-empty {
  padding: 40px 20px;
  text-align: center;
  color: #9ca3af;
  font-size: 14px;
  line-height: 1.6;
}

/* Mobile Responsive */
@media (max-width: 640px) {
  .account-combobox-dialog {
    max-width: calc(100% - 16px);
    width: calc(100% - 16px);
  }

  .account-combobox-modal-header {
    padding: 12px 16px;
    flex-wrap: wrap;
    gap: 12px;
  }

  .account-combobox-modal-title {
    font-size: 16px;
    flex: 1 1 100%;
  }

  .account-combobox-header-actions {
    flex: 1 1 100%;
    justify-content: space-between;
  }

  .account-combobox-toggle-label {
    font-size: 13px;
  }

  .account-combobox-search-wrapper {
    padding: 12px 16px;
  }

  .account-combobox-options {
    padding: 6px;
    max-height: calc(80vh - 160px);
  }

  .account-combobox-option {
    padding: 10px 12px;
  }
}
